// use this to namespace and contain any variables want exposed globally
var ih = ih || {};

(function( $ ) {

    // on DOM loaded

    //gdpr scroll box js
    $(function(){
        $(document).on("click", "#gdpr-scroll", function(){
            var $terms = $('.gdpr-compliance-terms');

            var scrollBy = $terms.height()-16;


            $terms.animate({
                scrollTop: '+=' + scrollBy + 'px'
            });
        });

        //gdpr terms stepper

        //on hide terms, close modal, show sorry alert
        $(document).on("click", ".reject-terms", function(e) {
            e.preventDefault();

            const msg = (
                "In order to create an account for you, we need to "            +
                "store your data. We understand your concern for privacy. "     +
                "You are welcome to register at any time in the future if you " +
                "change your mind."
            );

            ih.alert(msg, null, { title: "Sorry", queue: "alert" });
        });

        //on accept terms, hide terms of service, show email terms
        $(document).on("click", ".accept-terms", function(e) {
            e.preventDefault();

            $emailTerms     = $(".gdpr-email-terms");
            $termsOfService = $(".gdpr-terms-of-service");

            $emailTerms.show();
            $termsOfService.hide();
        });

        //on accept email terms, show sign up form
        $(document).on("click", ".continue-to-sign-up", function(e) {
            e.preventDefault();

            $emailTerms            = $(".gdpr-email-terms");
            $signUpFormInputs      = $(".sign-up-form-inputs");
            $backToEmailTermsLinks = $(".back-to-email-terms-link");

            $emailTerms.hide();
            $backToEmailTermsLinks.show();
            $signUpFormInputs.show();
        });

        //navigate back to email terms
        $(document).on("click", ".back-to-email-terms", function(e) {
            e.preventDefault();

            $emailTerms            = $(".gdpr-email-terms");
            $termsOfService        = $(".gdpr-terms-of-service");
            $signUpFormInputs      = $(".sign-up-form-inputs");
            $backToEmailTermsLinks = $(".back-to-email-terms-link");

            $emailTerms.show();
            $backToEmailTermsLinks.hide();
            $termsOfService.hide();
            $signUpFormInputs.hide();
        });

        //navigate back to email terms
        $(document).on("click", ".back-to-terms-and-conditions", function(e) {
            e.preventDefault();

            $emailTerms     = $(".gdpr-email-terms");
            $termsOfService = $(".gdpr-terms-of-service");

            $emailTerms.hide();
            $termsOfService.show();
        });

        //disable continue button until a selection has been made for both email options
        $(document).on("click", ".gdpr_housetrack_email_opt_in, .gdpr_marketing_email_opt_in", function(e) {
            const htEmailOptionChecked        = $("input[name='radios-gdpr_marketing_email_opt_in']:checked").val();
            const marketingEmailOptionChecked = $("input[name='radios-gdpr_housetrack_email_opt_in']:checked").val();

            if (htEmailOptionChecked && marketingEmailOptionChecked) {
                $('.continue-to-sign-up').prop("disabled", false);
            }
        });


        // NOTE: the DOM needs to be loaded first, or else document.body will be undefined
        function getScrollTopElement() {

            // first check for missing doctype (quirks mode) - always use 'body'
            if (document.compatMode !== 'CSS1Compat') return 'body';

            // main case: has a doctype
            // most browsers will support the scrollTop property on EITHER html OR body
            // we'll have to do a quick test to detect which one...

            // NOTE that the html tag is really document.documentElement in the DOM
            var html = document.documentElement;
            var body = document.body;

            // get our starting position.
            var startingY = window.pageYOffset || body.scrollTop || html.scrollTop;

            // scroll the window down by 1px (works in all browsers)
            var newY = startingY + 1;

            window.scrollTo(0, newY);

            // Check if the property changed
            // FF and IE use only html. Safari uses only body.
            // Chrome has values for both, but says body.scrollTop is deprecated when in Strict mode.,
            // so let's check for html first.
            var element = ( html.scrollTop === newY ) ? 'html' : 'body';

            // now reset back to the starting position
            window.scrollTo(0, startingY);

            return element;
        }

        // global var - should always be either "body" or "html";
        // we'll use this as the selector for our page scrolling animation.
        ih.scrollTopElement = getScrollTopElement();

        // define breakpoints
        var bp_phone_portrait = '320px';
        var bp_phone_landscape = '480px';
        var bp_tablet_portrait = '768px';
        var bp_tablet_landscape = '1024px';
        var bp_sm_desktop = '1024px';
        var bp_desktop = '1280px';
        var bp_lg_desktop = '1600px';

        var bp_nav_menu = '750px'; // >= you get horizontal nav
        var bp_nav_buttons = '900px'; // buttons added to horiz nav (menu icon disappears?)
        var bp_nav_phone = '1075px'; // phone gets added to horiz nav

        // toggle menu open/closed
        $(".nav_toggle").on("click", function(e) {
            e.preventDefault();
            $(".nav_menu").toggleClass("nav_menu_open");
            $(".nav_toggle").toggleClass("nav_toggle_open");
        });

        // if the viewport gets resized to at least desktop size,
        // "close" the menu (remove the "nav_open" css class name)
        // since it will be permanently visible anyways

        if ( typeof isIE8 == 'undefined' ) isIE8 = false;

        if ( isIE8 ) {
            // IE8 sucks... so they don't get the responsive version, just the desktop version
            $('body').addClass('ie8');
            $('.nav_menu').removeClass("nav_menu_open");
            $('.nav_toggle').removeClass("nav_toggle_open");
        }
        else {
            enquire.register("screen and (min-width:" + bp_nav_buttons + ")", {
                match : function() {
                    $('.nav_menu').removeClass("nav_menu_open");
                    $('.nav_toggle').removeClass("nav_toggle_open");
                }
            });
        }


         // attach lazyload events to images - need to initialize once for each region

         // callback for when lazy loading finishes for each image
         ih.lazyloaded = function( images_remaining, settings )
         {
             //console.log("this", this);
             //console.log("images_remaining", images_remaining);
             //console.log("settings", settings);
             $( this ).removeClass("loading").addClass("loaded");

             // when the last image in a region has loaded...
             ///if ( images_remaining == 0 ) {}
         };

         ih.lazyload_settings = {
             effect: "fadeIn",
             data_attribute: "lazyload",
             load: ih.lazyloaded,
             skip_invisible: false
         };
         // make this accessible globally

         $(".page img[data-lazyload]").lazyload(ih.lazyload_settings);
         // if the page layout has multiple columns, we may need to break these out to init once per column. For example:
         //$(".side_col img[data-lazyload]").lazyload(lazyload_settings);
         //$(".main_col img[data-lazyload]").lazyload(lazyload_settings);



         // ANCHORS
         // to do our own smooth scrolling, the anchor name/id that is referenced in the hash
         // must not exist (there's no way to stop the page from jumping otherwise)

         // so instead we use our own underscore prefix naming convention
         // example:
         // <a href="#your-mom">Your Mom</a>
         // ... more stuff on the page ...
         // <a name="_your-mom"></a>

         ih.anchor_scroll_offset = 80;


         // returns scrollTop
         var calculateScrollTop = function($anchor) {
             var scrollTop = 0;
             if ( $anchor !== undefined && $anchor.length ) {
                 scrollTop = $anchor.offset().top - ih.anchor_scroll_offset;

                 // change offset to accommodate for sticky headers
                 if ( $("#HeaderWrapperPlaceholder").length ) {
                     var stickyHeight = $("#HeaderWrapperPlaceholder").height();
                     scrollTop = scrollTop - stickyHeight;
                 }
             }
             return scrollTop;
         };


         ih.scroll_to_anchor = function(name) {
             var anchorName = ( name !== undefined ) ? name : window.location.hash.split("?")[0].replace('#', '');
             var anchor = $('a[name="_' + anchorName + '"]');

             if(anchor.length > 0) {
                 $(document).trigger("beforeScrollToAnchor", [anchorName]); // fire custom event callback for before the animation (not used yet?)
                 // animate
                 var scrollTop = calculateScrollTop(anchor);

                 $(ih.scrollTopElement).animate({ scrollTop: scrollTop }, 500)
                     .promise()
                     .then(function() {
                         $(document).trigger("scrollToAnchor", [anchorName]); // fire custom event callback for after the animation (not used yet?)
                     });
             }
             // back to top
             else if (anchorName == '_') {
                 ih.scroll_to_top();
             }
             // regular anchor case
             else {
    //             console.log("no matching anchor found. don't scroll!");
                 var anchor = $('a[name="' + anchorName + '"]');
                 if (anchor.length) {
                     var scrollTop = calculateScrollTop(anchor);
                     $(ih.scrollTopElement).scrollTop(scrollTop);
                 }
             }
         };

         ih.scroll_to_top = function() {
             $(ih.scrollTopElement).animate({ scrollTop: 0 }, 500);
         };

         // call once when page loads
//         setTimeout( function() {
//             ih.scroll_to_anchor();
//         }, 300 );

         // call once when page loads and again on every hash change
         $(window).on('load', function(e) {
             ih.scroll_to_anchor();

             // wait for any sticky nav stuff to render, then try again
             if ( $("#HeaderWrapperPlaceholder").length ) {
                 setTimeout( function() {
                     ih.scroll_to_anchor();
                 }, 1200 );
             }
         });
         $(window).on('hashchange', function(e) {
             ih.scroll_to_anchor();
         });

         // check for a "back to top" link on the page
         if ( $("a.back_to_top").length > 0 ) {
             $( window ).on("scroll", function(e) {
                 var $btt =  $("a.back_to_top");
                 var st = $(ih.scrollTopElement).scrollTop();
                 if ( st > 0 ) {
                     $btt.addClass('active');
                 }
                 else {
                     $btt.removeClass('active');
                 }
             });
         }

         $(".ih-dom-loading").removeClass("ih-dom-loading");


         // if there were form errors on DOM load
         // scroll the page to the first field and THEN focus it.
         // (if you focus it first, the page jumps to it immediately and screws up the animation)
         if ( $(".has_error, .has-error, .ih-has-error").length ) {
             var $firstError = $(".has_error, .has-error, .ih-has-error").first();

             setTimeout( function() {
                 $(ih.scrollTopElement).animate({ scrollTop: $firstError.offset().top - 100 }, 500, function() {
                     $firstError.focus();
                 });
             }, 500);
             ih.error("Oops! There were problems.", { autoClose: 2 });
         }

         // allow for 3rd party forms to use our client-side validation UI
         // (so long as the markup is structured the same as our forms)
         // just attach the class "ih-form-validation" to the form.
         ih.form.attachValidationEvents(".ih-form-validation");

         // attach tooltips to any inputs with a title attribute
         $("input[title]").tooltip();

         $('body').on('click', 'a[data-link-type="folder"]', function(e) {
             $(this).parent().toggleClass("sub-nav-open");
             return false;
         });


         ih.navModalForm =  function(e) {
             // block the click event
             e.preventDefault();

//             console.log("ih.navModalForm", e, ih);

             // the custom_form_id is in the "data" element data-form_id
             var href = $(this).attr('href');

             var url = "";

             var custom_form_id = $(this).data("form-id");
             var key_id = $(this).data("key-id");
             var agent_id = $(this).data("agent-id");

             if( custom_form_id !== undefined )
             {
//                 console.log("custom_form_id NOT UNDEFINED");
                 url = "/AjaxForm/get_form_definition/?form_id=" + custom_form_id;
             }
             else
             {
//                 console.log("custom_form_id UNDEFINED");
                 url = "/AjaxForm/get_form_definition/?key_id=" + key_id;
             }


             if( agent_id !== undefined )
             {
//                 console.log("custom_form_id NOT UNDEFINED");
                 url += "&agent_id=" + agent_id;
             }

             // retrieve the form definition and show the form
             $.ajax({
                 url: ih.url( url ),
                 data: { },
                 dataType: 'json',
                 type: 'POST',
                 success: function (data) {

                     if ( data.tracking_events ) {
                         for(var index  in data.tracking_events) {
                             $(document).trigger("trackingEvent", data.tracking_events[index]);
                         }
                     }

                     data.form_object['form']['action'] = href;
                     data.form_object['use_captcha'] = data['use_captcha'] ? true : false;

                     // using a custom success callback to handle our tracking events
                     data.form_object['form']['success'] = function(response, form) {
                         ih.success(response.message);
                         if ( response.tracking_events ) {
                             for(var index  in response.tracking_events) {
                                 $(document).trigger("trackingEvent", response.tracking_events[index]);
                             }
                         }
                     };

                     ih.modalForm( "", null, data.form_object );
                 }
             });
         };



         ih.modalRegistrationOpen =  function(href, key_id, forcedReg ) {

//             console.log('href', href, 'key_id', key_id, 'forcedReg', forcedReg);

             var url = "/AjaxForm/get_form_definition/?key_id=" + key_id;

             // retrieve the form definition and show the form
             $.ajax({
                 url: ih.url( url ),
                 data: {on_page:document.title },
                 dataType: 'json',
                 type: 'POST',
                 success: function (data) {

//                     console.log("form definition data:", data);

                     var settings = settings = data.form_object;
                     var message = '';

                     var trackingEventExtraDimensions = {};


                     if(data.simple_form) {
                         trackingEventExtraDimensions.registration_form_type = 'simple';
                     } else if(data.simple_form !== undefined) {
                         trackingEventExtraDimensions.registration_form_type = 'custom';
                     }

                     if(forcedReg) {
                         trackingEventExtraDimensions.registration_form_mode = 'hard';
                     } else {
                         trackingEventExtraDimensions.registration_form_mode = 'soft';
                     }

                     if(data.split_test) {
                         trackingEventExtraDimensions.split_test = data.split_test;
                     }

                     $(document).trigger("trackingEventExtraDimensions", trackingEventExtraDimensions);



                     if ( data.tracking_events ) {
                         for(var index  in data.tracking_events) {
                             $(document).trigger("trackingEvent", data.tracking_events[index]);
                         }
                     }

                     settings['replaceCurrent'] = true;
                     settings['form']['action'] = href;
                     settings['use_captcha'] = data.use_captcha ? true : false;

                     // using a custom success callback to handle our tracking events
                     settings['form']['success'] = function(response, form) {
                         ih.success(response.message);

                         if(response.split_test) {
                             $(document).trigger("trackingEventExtraDimensions", {'split_test': response.split_test });
                         }

                         if ( response.tracking_events ) {
                             for(var index  in response.tracking_events) {
                                 $(document).trigger("trackingEvent", response.tracking_events[index]);
                             }
                         }

                         if(response.redirect_url) {
                             window.location = response.redirect_url;
                         } else {
                             if(key_id == 'register' && ih.data.registrationFollowup  && !response.skip_followup) {

//                                 console.log("Force followup?", ih.data.modalTeaserForceRegistration && ih.data.openModalTeaserRegistration);

                                 ih.modalRegistrationOpen(ih.data.modalRegistrationFollowupHref, 'followup', ih.data.modalTeaserForceRegistration && ih.data.openModalTeaserRegistration );
                             }
                             else {
                                    if( ih.data.sassEnabled == true ) {
                                         window.store.dispatch(window.getUser());
                                    }else {
                                        location.reload();
                                    }
                             }
                         }
                     };

                     // using a custom failure callback to trigger redirects and form swaps
                     settings['form']['failure'] = function(response, form) {
                         ih.error( response.message, { autoClose: 2 });

//                         console.log('custom failure', response);

                         if ( response.tracking_events ) {
                             for(var index  in response.tracking_events) {
                                 $(document).trigger("trackingEvent", response.tracking_events[index]);
                             }
                         }

                         if ( response.form && response.form.errors ) {
                             form.errors( response.form.errors );
                         }
                         $(".ih-has-error").first().focus();

                         if(response.redirect_url) {
                            if( ih.data.sassEnabled == true ){
                                 window.store.dispatch(window.getUser());
                            }else {
                                 window.location = response.redirect_url;
                            }

                         }
                     };

                     if(key_id == 'followup') {
                         settings['close'] = function() {
                            if( ih.data.sassEnabled == true ) {
                                 window.store.dispatch(window.getUser());
                            } else {
                                 location.reload();
                            }

                         };

                         settings['buttons'] = {
                                 cancel: {
                                   callback: function() {
                                      if( ih.data.sassEnabled == true ) {
                                           window.store.dispatch(window.getUser());
                                      } else {
                                           location.reload();
                                      }
                                   }
                               }
                           };
                     }

                     if(forcedReg) {
                         settings['closeButton'] = false;
                         settings['cancelButton'] = false;
                         settings['open'] = function() {
                             $("body").addClass("ih-blur-content")
                             //ih.form.reCaptcha.render();
                         };

                     } else {
                         settings['open'] = function() {
                             // ih.form.reCaptcha.render();
                         };
                     }

                     ih.modalForm( message, null, settings);
                 }
             });
         };

         ih.modalRegistration =  function(e) {
             // block the click event
             if (e != undefined) {
                 e.preventDefault();
             }

             // the custom_form_id is in the "data" element data-form_id

             var href = $(this).attr('href');
             var key_id = $(this).data("key-id");

             var forcedReg = false;

             // if there's a modal open a already, close it (and preserve its mode if appropriate)
             if(ih.currentModal != undefined) {

                 // if teaser mode is hard and this was a forced open registration modal
                 forcedReg = ih.data.modalTeaserForceRegistration && ih.data.openModalTeaserRegistration;
             }

             ih.modalRegistrationOpen(href, key_id, forcedReg);
         };



         ih.socialRegisterCallback = function( user, data ) {
//             console.log("CALLBACK", user, data);

             var isModalForm = data.isModalForm;
             var $form = data.form;

             $form.find("[name='social_login_id']").val(user['id']);
             $form.find("[name='email-']").val(user['email']);
             $form.find("[name='email']").val(user['email']);
             $form.find("[name='social_login_data']").val(JSON.stringify(user));

             if(isModalForm && ih.currentModal != undefined) {
//                 console.log("MODAL FORM", ih.currentModal);
                 ih.currentModal.close('confirm');
             } else {
//                 console.log("PAGE FORM", $form);
                 $form.submit();
             }
         };



         ih.socialRegister = function(e) {
             // block the click event
             if(e != undefined) {
                 e.preventDefault();
             }

//             var isModalForm = $(this).is('div');
             var isModalForm = e.data.isModalForm;
             var provider = e.data.provider;
             var providerClass = provider + 'login';

             var $form = $(this).closest('form');

             console.log("social login clicked", provider);
             console.log('isModalForm', isModalForm);
             console.log('$form', $form);

             ih[providerClass].callback = ih.socialRegisterCallback;
             ih[providerClass].callbackData = {form: $form, isModalForm: isModalForm} ;
             ih[providerClass].login();

         };


//         console.log("ihouseweb.com_deferred: registering modal handlers if appropriate", ih.data.template);



         // New safe code - just check for the existence of the above and turn the functions into noops.
         if ( ih.data && ih.data.template && ih.data.template.isReact ) {
             ih.navModalForm = function() {};
             ih.modalRegistration = function() {};
         }

         // defeat the popup forms - grab the click event and load up the correct form
         $('body').on('click', 'a[target="modal_form"]', ih.navModalForm);
         $('body').on('click', 'a[target="modal_register"]', ih.modalRegistration);

        $('body').on('click', 'form.custom-form-widget-form .facebook-button-login', {provider: 'facebook', isModalForm: false},  ih.socialRegister);
        $('body').on('click', 'div.custom-form-widget-form .facebook-button-login',  {provider: 'facebook', isModalForm: true},  ih.socialRegister);

        $('body').on('click', 'form.custom-form-widget-form .google-button-login', {provider: 'google', isModalForm: false},  ih.socialRegister);
        $('body').on('click', 'div.custom-form-widget-form .google-button-login',  {provider: 'google', isModalForm: true},  ih.socialRegister);

        if(ih.data.openModalTeaserRegistration)
        {
            grecaptcha.ready(function() {
                ih.modalRegistrationOpen(ih.data.modalTeaserRegistrationHref, 'register', ih.data.modalTeaserForceRegistration);
            });
        }

        if(ih.data.mustAcceptTOS)
        {

            ih.modal({
                title:(ih.data.acceptedTOS?'Updated':'Accept')+' Terms',
                message: "<p>"+(ih.data.acceptedTOS?"Our terms of service have been updated.":"Please accept the terms of service.")+"</p>"+
                         (ih.data.acceptedTOS&&ih.data.tos.summary?"<h4 class=\"ih-modal-title\">Summary of Changes</h4><div class=\"terms\">"+ih.data.tos.summary+"</div>":'')+
                         "<h4 class=\"ih-modal-title\">Terms of Service</h4><div class=\"terms\">"+ih.data.tos.terms+"</div>",
                mask:true,
                clickOutToClose:false,
                closeButton:false,
                cssClass:'tos-modal',
                form:{
                    name:'accept_tos',
                    action:ih.url("/WebAdmin/accept_tos"),
                    valueOnSingularField:false,
                    fields:[
                        {
                            type:'html',
                            html:"<div><input type=\"checkbox\" name=\"accept_tos\" id=\"accept_tos_checkbox\"/>"+
                                 "<label for=\"accept_tos_checkbox\">By checking this box, I am agreeing to the Terms of Service (TOS) above.</label></div>"
                        },
                        {
                            type:'html',
                            html:"<div><input type=\"checkbox\" name=\"accept_messaging\" id=\"accept_messaging_checkbox\"/>"+
                                 "<label for=\"accept_messaging_checkbox\">By checking this box I am agreeing to allow iHOUSEweb, Inc to send me automated text messages "+
                                 "and/or calls to the phone number I have provided.</label></div>"
                        },
                        {
                            type:'html',
                            html:"<div><input type=\"checkbox\" name=\"accept_accessibility\" id=\"accept_accessibility_checkbox\"/>"+
                                 "<label for=\"accept_accessibility_checkbox\">By checking this box I understand that by having a public facing website, I may be obligated "+
                                 "to ensure my website is accessible to persons with communicative disabilities including those with vision and/or hearing impairments and "+
                                 "that a failure to do so may expose me to legal liability under both State and Federal law.  I further understand that iHOUSEweb makes no "+
                                 "representations or warranties related to its website platform’s accessibility as such an evaluation and analysis is best achieved through "+
                                 "the retention of an expert specializing in access compliance.</label></div>"
                        },
                        {
                            type:'hidden',
                            name:'source',
                            value:'modal'
                        }

                    ],
                },
                buttons: {
                    confirm: {
                        label: "I Accept",
                        id:'accept_tos_button',
                        cssClass: "ih-modal-button-primary",
                    }
                },
            })

            var btn=$('#accept_tos_button')[0];
            btn.disabled=true

            var tos=$('#accept_tos_checkbox')[0];
            var msg=$('#accept_messaging_checkbox')[0];
            var acc=$('#accept_accessibility_checkbox')[0];
            tos.onchange=msg.onchange=acc.onchange=function(btn,tos,msg,acc){return function(e){btn.disabled=!tos.checked||!msg.checked||!acc.checked}}(btn,tos,msg,acc);

        }


    }); // end on DOM loaded

})(jQuery);
